import { imgCache } from '@/services/img-cache.js';
import { HatElement } from '@/components/hat-element.js';

class HatImage extends HatElement {
  private _placeholder: Element | null = null;
  private _img: HTMLImageElement | null = null;
  private _documentId: string | null = null;

  static get observedAttributes() {
    return ['document-id'];
  }

  connectedCallback() {
    super.connectedCallback();
    const type = this.getAttribute('type') || 'thumbnail';
    this.root.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
          height: 100%;
        }

        .image-wrapper {
          width: 100%;
          height: 100%;
          position: relative;
        }

        .placeholder {
          width: 100%;
          height: 100%;
          background: #ddd;
          border-radius: 8px;
        }

        .fullsize {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          border-radius: 10px;
          object-fit: contain;
          cursor: pointer;
          display: block;
        }

        .expanded {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          border-radius: 0;
          object-fit: contain;
          cursor: pointer;
          display: block;
        }

        .thumbnail {
          width: 80px;
          height: 80px;
          border-radius: 10px;
          object-fit: cover;
          cursor: pointer;
          display: block;
        }

        .hidden {
          display: none;
        }
      </style>

      <div class="image-wrapper">
        <div class="placeholder"></div>
        <img class="${type} hidden" alt="image" />
      </div>
    `;

    this._placeholder = this.root.querySelector('.placeholder');
    this._img = this.root.querySelector('img');

    this.init();
  }

  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
    if (name === 'document-id' && newValue !== oldValue) {
      this._documentId = newValue;
      this.loadData();
    }
  }

  async init() {
    if (this.hasAttribute('document-id')) {
      this._documentId = this.getAttribute('document-id');
      this.loadData();
    }
  }

  async loadData() {
    if (!this._placeholder || !this._img) return;

    if (this._documentId) {
      this._placeholder.classList.remove('hidden');
      this._img.classList.add('hidden');

      await imgCache.loadImage(this._documentId, this._img);

      this._img.onload = () => {
        this._placeholder!.classList.add('hidden');
        this._img!.classList.remove('hidden');
      };
    } else {
      this._img.classList.add('hidden');
      this._placeholder.classList.remove('hidden');
    }
  }
}

customElements.define('hat-image', HatImage);